define("shared/components/shared/feature-upgrade-banner", ["exports", "@ember/component", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="cBU--banner" data-test-id="feature-upgrade-banner">
    <div class="cBU--banner__background" style={{concat "--background-url: url('" @backgroundImageUrl "');"}}>
    </div>
  
    <div class="cBU--banner__content">
      <div class="cBU--banner__left">
        <div class="cBU--banner__featureButton">
          {{svg-jar @featureIcon class="o--icon cBU--banner__featureButton--icon" role="img" title=@featureIcon}}
          <span class="cBU--banner__featureButton--text" data-test-id="feature-title">{{@featureTitle}}</span>
        </div>
  
        <div class="u--p__lr__md">
          <p class="cBU--banner__title">{{t "plans.upgrade.unlock_banner.title"}}</p>
          <p class="cBU--banner__description" data-test-id="banner-description">{{@description}}</p>
        </div>
      </div>
  
      <div class="cBU--banner__upgradeButton--container">
        <Shared::Button::Upgrade
          @class="cBU--banner__upgradeButton"
          @feature={{@upgradeFeature}}
          @location={{@upgradeLocation}}
          @size="regular"
          @text={{t "plans.upgrade.unlock_banner.button"}}
          @trialText={{t "plans.upgrade.unlock_banner.button"}}
          data-qa-id="feature_upgrade_button"
        />
      </div>
    </div>
  </div>
  */
  {
    "id": "YUcLkD7Y",
    "block": "[[[10,0],[14,0,\"cBU--banner\"],[14,\"data-test-id\",\"feature-upgrade-banner\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"cBU--banner__background\"],[15,5,[28,[37,0],[\"--background-url: url('\",[30,1],\"');\"],null]],[12],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"cBU--banner__content\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"cBU--banner__left\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"cBU--banner__featureButton\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[[30,2]],[[\"class\",\"role\",\"title\"],[\"o--icon cBU--banner__featureButton--icon\",\"img\",[30,2]]]]],[1,\"\\n        \"],[10,1],[14,0,\"cBU--banner__featureButton--text\"],[14,\"data-test-id\",\"feature-title\"],[12],[1,[30,3]],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,0],[14,0,\"u--p__lr__md\"],[12],[1,\"\\n        \"],[10,2],[14,0,\"cBU--banner__title\"],[12],[1,[28,[35,2],[\"plans.upgrade.unlock_banner.title\"],null]],[13],[1,\"\\n        \"],[10,2],[14,0,\"cBU--banner__description\"],[14,\"data-test-id\",\"banner-description\"],[12],[1,[30,4]],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"cBU--banner__upgradeButton--container\"],[12],[1,\"\\n      \"],[8,[39,3],[[24,\"data-qa-id\",\"feature_upgrade_button\"]],[[\"@class\",\"@feature\",\"@location\",\"@size\",\"@text\",\"@trialText\"],[\"cBU--banner__upgradeButton\",[30,5],[30,6],\"regular\",[28,[37,2],[\"plans.upgrade.unlock_banner.button\"],null],[28,[37,2],[\"plans.upgrade.unlock_banner.button\"],null]]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@backgroundImageUrl\",\"@featureIcon\",\"@featureTitle\",\"@description\",\"@upgradeFeature\",\"@upgradeLocation\"],false,[\"concat\",\"svg-jar\",\"t\",\"shared/button/upgrade\"]]",
    "moduleName": "shared/components/shared/feature-upgrade-banner.hbs",
    "isStrictMode": false
  });
  class FeatureUpgradeBannerComponent extends _component2.default {}
  _exports.default = FeatureUpgradeBannerComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, FeatureUpgradeBannerComponent);
});